import { TeacherPage } from "@/components/teacher/TeacherPage";
import { ClassroomStudents } from "@/components/teacher/classroom/ClassroomStudents";
import { useT } from "@/i18n";
import { ClassroomBreadcrumb } from "./ClassroomBreadcrumb";
import type { ClassroomScope } from "./classroomScope";
import { useAdminClassroomSchool, useClassroomName } from "./useClassroomData";

export function ClassroomDetailPage({
  classroomId,
  scope = "teacher",
}: { classroomId: string; scope?: ClassroomScope }) {
  const t = useT();
  const classroomName = useClassroomName(scope, classroomId);
  const school = useAdminClassroomSchool(scope, classroomId);

  return (
    <TeacherPage
      title={classroomName ?? t["classroom.fallbackName"]}
      embedded={scope === "admin"}
      breadcrumb={
        <ClassroomBreadcrumb
          scope={scope}
          school={scope === "admin" ? school : undefined}
          classroom={classroomName}
        />
      }
    >
      <ClassroomStudents classroomId={classroomId} scope={scope} />
    </TeacherPage>
  );
}
